import { jsx as _jsx } from "react/jsx-runtime";
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import { Fade } from '@clds/transitions';
import { ModalOverlay, } from './ModalOverlay/ModalOverlay.js';
import { modalNextTheme } from './theme.js';
const StyledFade = styled(Fade) `
  /** Prevents stacking context issues, see https://stackoverflow.com/a/11742116 */
  position: fixed;
  z-index: ${modalNextTheme.overlay.zIndex};
`;
/**
 * Modal uses React portal to appear in the different DOM node.
 * it will mount itself inside the div at the end of the `<body>` by default
 * it can take DOM node to portal as well using `customNode` prop.
 */
export const Modal = ({ children, isOpen, customNode, className, ...modalOverlayProps }) => {
    const timeout = modalNextTheme.fadeDuration;
    return createPortal(_jsx(StyledFade, { timeout: timeout, in: isOpen, "data-test": "fade", className: className, children: _jsx(ModalOverlay, { ...modalOverlayProps, "data-test": "modal-overlay", children: children }) }), 
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    customNode || document.body);
};
